import { render, staticRenderFns } from "./particles.vue?vue&type=template&id=13a84558&scoped=true"
import script from "./particles.vue?vue&type=script&setup=true&lang=js"
export * from "./particles.vue?vue&type=script&setup=true&lang=js"
import style0 from "./particles.vue?vue&type=style&index=0&id=13a84558&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13a84558",
  null
  
)

export default component.exports